import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e716120"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("数据校验")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("匹配流水")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载关单备注导入模板")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导入关单备注")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("批量锁定")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("批量解锁")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("同步MT数据")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("同步approved状态核销")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("重算payoneer")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("检测译员")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("修改金额")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px"} }, [
  /*#__PURE__*/_createTextVNode(" 1.敏感国家校验是校验指定邮箱为xxxxxx@gmail.com ，需要标记 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2.译员币种为USD时，付款公司如果不是CCJK CO LIMITED，要标记；译员币种为CNY时,付款公司如果不是深圳市昆仲科技有限公司或深圳市昆仲科技有限公司（云账户)，要标记。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3.Bank方式： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ccjk："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 收款人名字 英文 允许有特殊字符（例如- . ，，；等等），空格（前后不能有空格） 银行名字 银行地址 收款人地址 英文，允许有字符数字空格 国际代码校验如果是纯数字，需要标记 银行国家不用校验 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 国内公司："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 收款人名字 中文 允许有·这个特殊字符（例如：吐尔孙·依明） 空格（前中后不能有空格） 银行名字 银行地址 收款人地址 中文，允许有字符数字字母空格 国际代码和银行国家不用校验 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4.当“银行名字” 和 “收款单位或人员全称”显示一样的时候需要标记 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 5.PayPal/Payoneer/Wise 判断账号是否为邮箱格式，如不是，请标记提示更正 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 6.‘支付币种’、‘开票类型’、‘服务方类型’为空的--需标记 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 7.wise方式的名字为英文，允许有特殊字符（例如- . ，，；等等），空格（前后不能有空格） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 8.当服务类型为云账户时，检查身份证及手机号码，如为空请标记 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 9.（付款公司）深圳市昆仲科技有限公司=（服务费类型）同行公司，（付款公司）深圳市昆仲科技有限公司（云账户）= （服务费类型）云账户，若不是请标记 ")
], -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("确定")

import {ref, computed, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle, getNumber } from '@/utils/index'
import PaymentModuleUtils, { makeInvoiceTypeOption, serviceTypeOption } from "@/views/typeMapping/PaymentModuleUtils"
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
import router from '@/router'

export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: any
}

const {statusFilter} = PaymentModuleUtils
const {
  'POST/cost_cash_packs/detail': fetchList,
  // 获取国家和公司
  'GET/cost_cash_packs/detail/queryList': queryListApi,
  // 国别列表
  'GET/order/receivable/clients/countries': countriesListApi,
  // 数据检查
  'POST/cost_cash_packs/detail/check/data': checkDataApi,
  // 敏感国家检查
  'POST/cost_cash_packs/detail/check/country': checkCountryApi,
  // 特殊字符校验
  'POST/cost_cash_packs/detail/check/char': checkCharApi,
  // 更新
  'POST/cost_cash_packs/details/update': updateApi,
  // 导出
  'POST/cost_cash_packs/detail/export': exportApi,
  // 删除
  'POST/cost_cash_packs/details/delete': delApi,
  // 获取预付款金额
  'POST/cost_cash_packs/details/advance_amount':advanceAmountApi,
  // 更新金额
  'POST/cost_cash_packs/details/amount/update':amountUpdateApi,
  // 下载关单备注导入模板
  'GET/cost_cash_packs/download/close_notes':downloadNotesTemplateApi,
  // 导入关单备注
  'POST/cost_cash_packs/import/close_notes':importNotesTemplageApi,
  // 支付包详情_批量锁定
  'POST/cost_cash_packs/detail/lock': lockApi,
  // 支付包详情_批量解锁
  'POST/cost_cash_packs/detail/unlock': unlockApi,
  // 同步MT数据
  'POST/cost_cash_packs/detail/sync_mars': sync_marsApi,
  // 同步MT结果
  'POST/cost_cash_packs/detail/sync_mars_approve': sync_marsResultApi,
  // 重算PaynoeerFee
  'POST/cost_cash_packs/detail/compute_fee': compute_feeApi,
  // 提现包详情 驳回
  'POST/cost_cash_packs/detail/reject': rejectApi,
  // 提现包 译员状态检测
  'POST/cost_cash_packs/detail/check_translator_status': check_translator_statusApi,
} = Api


let selectionRows = ref([])
const rowIds = computed(() => selectionRows.value.reduce((arr: number[], row: any) => {
  if(!row.children || row.children?.length === 0){
    arr.push(row.id)
  }
  return arr
  }, [])
)
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let countrieList: any = ref([])
let companyList: any = ref([])
onBeforeMount(() => {
  /* countriesListApi().then((rep: any) => {
    countrieList.value = rep.map((label: string) => ({ label, id: label }))
  }) */
  queryListApi().then((rep: any) => {
    let { countries, companies } = rep
    countrieList.value = countries.map((e: any) => ({label: e, id: e}))
    companyList.value = companies.map((e: any) => ({label: e, id: e}))
  })

  MI_params.packId = props.id
})

const searchConfig = ref([
  {
    type: 'SELECT',
    label: '付款方式',
    value: [],
    upKey: 'payMethod',
    options: [
      { label: 'PAYPAL', id: 'paypal' },
      { label: 'WISE', id: 'wise' },
      { label: 'BANKTRANSFER', id: 'banktransfer' },
      { label: 'PAYONEER', id: 'payoneer' },
      { label: 'PAYONEERBANKTRANSFER', id: 'payoneerbanktransfer' },
    ],
    props: { clearable: true, placeholder: '请选择付款方式', multiple: true, 'collapse-tags': true },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    type: 'SELECT',
    label: '火星同步',
    value: '',
    upKey: 'syncMarsStatus',
    options: [
      { label: '未同步', id: 'not_synced' },
      { label: '失败', id: 'failed' },
    ],
    props: { clearable: true, placeholder: '请选择火星同步'},
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    type: 'SELECT',
    label: '国家',
    value: '',
    upKey: 'beneficiaryBankCountry',
    options: countrieList,
    props: {clearable: true, placeholder: '请选择国家',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '付款公司',
    value: '',
    upKey: 'companyList',
    options: companyList,
    props: {clearable: true, placeholder: '请选择付款公司',multiple: true, 'collapse-tags': true },
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    label: '最小金额',
    value: '',
    upKey: 'paymentAmountFrom',
    // rule: [{ type: 'number', message: '请输入数字' },]
    // props: {clearable: true}
  },
  {
    label: '最大金额',
    value: '',
    upKey: 'paymentAmountTo',
    // rule: [{ type: 'number', message: '请输入数字' },]
    // props: {clearable: true}
  },
  {
    label: '译员ID',
    value: '',
    upKey: 'resourceId',
  },
  {
    label: '收款单位或人员全称',
    value: '',
    upKey: 'beneficiaryName',
  },
  {
    type: 'SELECT',
    label: '状态',
    value: '',
    upKey: 'status',
    options: [
      { label: 'Approved', id: 'Approved' },
      { label: 'Pending', id: 'Pending' },
      { label: 'Rejected', id: 'Rejected' },
      { label: 'Locked', id: 'Locked' },
    ],
    props: { clearable: true },
    placeholder: '请选择状态',
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '进度',
    value: '',
    upKey: 'dataStatus',
    options: [
      { label: '已处理', id: 'processed' },
      { label: '待处理', id: 'pending_processing' },
      { label: '部分处理', id: 'partial_processing' },
    ],
    props: { clearable: true, placeholder: '请选择进度' },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    type: "TIME",
    label: "同步火星时间",
    value: '',
    upKey: 'ranges',
    upProps: { startKey: 'syncMarsFrom', endKey: 'syncMarsTo', },
    props: {
      type: 'daterange',
      clearable: true,
      'default-value': null,
    }
  },
])

// 表格列显示过滤
const filteredColOpt = [
  '银行名字',
  '银行地址',
  '银行国家/地区',
  '银行代号或国际汇款代码',
  '收款人地址',
  '收款人身份证号',
  '收款人联系电话',
  '备注',
  '开票类型',
  '服务方类型',
  '汇率',
  '适用增值税税率',
  '扣除手续费',
  'paypal手续费',
  '云账户服务费',
  '云账户返点',
  '手动修改金额',
  '提现单核销金额',
  '预付单核销金额',
  '核销币种',
  '差异金额',
  '差异率',
  '关单人',
  '关单时间',
  '关单备注',
  '同步火星人',
  '同步火星时间',
  '译员账户状态',
  '进度',
  '提现单状态',
]
const filteredColumn = ref([])
const isColumnHidden = (columnKey: string) => !filteredColumn.value.includes(columnKey)

const rowTotal: any = reactive({})
const searchHandle = (params: any) => {
  if(!/^(?:\d*\.\d+|\d+|\s*)$/.test(params.paymentAmountFrom.trim()) || !/^(?:\d*\.\d+|\d+|\s*)$/.test(params.paymentAmountTo.trim())){
    ElMessage.warning('金额搜索请输入数字')
    return
  }
  if( /^-?\d+(\.\d+)?$/.test(params.paymentAmountTo.trim()) && params.paymentAmountFrom.trim() > params.paymentAmountTo.trim()){
    ElMessage.warning('最小金额大于最大金额')
    return
  }
  tipsRows.value = []
  fetchData(params).then(({sumData}: any) => {
    isUnderCheck.value = false
    // 表尾合计
    Object.assign(rowTotal, sumData)
  })
}

// 判断是否检查
const isUnderCheck = ref<boolean>(false)
const pageCg = (page: number) => {
  if(isUnderCheck.value){
    dataCheck()
    return
  }
  MI_pageChange(page)
} 

const sizeCg = (size: number) => {
  if(isUnderCheck.value){
    dataCheck()
    return
  }
  MI_sizeChange(size)
}

let tipsRows: any = ref<string[]>([])
let tipsObj: any = ref({})

// 数据校验
const isShowCheck = ref<boolean>(false)

const dataCheck = () => {

    MI_identify.value = true
    checkDataApi({...MI_params, page: page.value, size: size.value}).then((rep: any) => {
    isUnderCheck.value = true
    tipsObj.value = rep.errorMap
    tipsRows.value = Object.keys(rep.errorMap)

    ElMessage.success('已验证数据')
    isShowCheck.value = false
    MI_identify.value = false
    MI_tableData.value = rep.data
  }).catch(() => {
    MI_identify.value = false
    isUnderCheck.value = false
  })
}


const tipsCellHandle = ({ row, column, rowIndex, columnIndex }: any) => {
  if(row.manualUpdateAmount!=0 && column.property === 'actualPaymentAmount'){
    return 'red-cell'
  }
  if(row.diff === true){
    return 'warning-cell'
  }
  // 支付币种和译员币种不一致
  if(row.resourceCurrency !== row.payCurrency && ['payCurrency', 'resourceCurrency', 'exchangeRate'].includes(column.property)){
    return 'blue-cell'
  }
  if(tipsRows.value.includes(row.id + '') && tipsObj.value[row.id].includes(column.property)){
    return 'warning-cell'
  }
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyConfig = ref([
  /* {
    label: '译员邮箱',
    value: '',
    upKey: 'resourceEmail',
  }, */
  {
    label: '译员名字',
    value: '',
    upKey: 'resourceName',
  },
  {
    type: 'SELECT',
    label: '付款方式',
    value: '',
    upKey: 'payMethod',
    options: [
      { label: 'PAYPAL', id: 'paypal' },
      { label: 'WISE', id: 'wise' },
      { label: 'BANKTRANSFER', id: 'banktransfer' },
      { label: 'PAYONEER', id: 'payoneer' },
      { label: 'PAYONEERBANKTRANSFER', id: 'payoneerbanktransfer' },
    ],
    props: { clearable: true, placeholder: '请选择付款方式' },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    label: '账号',
    value: '',
    upKey: 'accountNumber',
  },
  {
    label: '银行名字',
    value: '',
    upKey: 'bankName',
  },
  {
    label: '银行地址',
    value: '',
    upKey: 'bankAddress',
  },
  {
    label: '银行代号或国际汇款代码',
    value: '',
    upKey: 'beneficiaryBankSwiftAddress',
  },
  {
    label: '收款单位或人员全称',
    upKey: 'beneficiaryName',
    value: '',
  },
  {
    label: '收款人地址',
    value: '',
    upKey: 'beneficiaryAddress',
  },
  {
    label: '收款人身份证号',
    value: '',
    upKey: 'beneficiaryCardId',
  },
  {
    label: '收款人联系电话',
    value: '',
    upKey: 'beneficiaryPhone',
  },
  {
    label: '译员币种',
    value: '',
    upKey: 'resourceCurrency',
  },
  {
    label: '提现金额',
    value: '',
    upKey: 'paymentAmount',
  },
  {
    label: '汇率',
    value: '',
    upKey: 'exchangeRate',
  },
  // {
  //   label: '支付金额',
  //   value: '',
  //   upKey: 'actualPaymentAmount',
  // },
  {
    type: 'SELECT',
    label: '国家',
    value: '',
    upKey: 'beneficiaryBankCountry',
    options: countrieList,
    props: {clearable: true, placeholder: '请选择国家', 'allow-create': true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '付款公司',
    value: '',
    upKey: 'company',
    options: companyList,
    props: {clearable: true, placeholder: '请选择付款公司', 'allow-create': true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    label: '备注',
    value: '',
    upKey: 'note',
    props: {maxlength: 200, type: 'textarea', style: 'width: 470px;'}
  },
  {
    label: '支付备注',
    value: '',
    upKey: 'payNotes',
    props: {maxlength: 200, type: 'textarea', style: 'width: 470px;'}
  },
])
const modifyHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async (params: any) => {
    await updateApi({
      ...row,
      ...params,
    })
    ElMessage.success('修改成功')
    modifyFg.value = false
    searchHandle(MI_params)
  })
}

// 修改错误行
const modifyErrRowHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async (params: any) => {
    await updateApi({
      ...row,
      ...params,
    })
    ElMessage.success('修改成功')
    modifyFg.value = false
    MI_tableData.value.splice(MI_tableData.value.indexOf(row), 1)
  })
}
// 行内编辑
const inlineEditHandle = (row: any) => {
  MI_identify.value = true
  updateApi(row).then(() => {
    ElMessage.success('修改成功')
    row.isShowEdit = false
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

// 删除
const delHandle = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  ElMessageBox.confirm('请确认是否删除', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    return delApi({ ids: selectionRows.value.map(e => e.id)}, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('删除成功')
    searchHandle(MI_params)
  })
}


// 导出
const exportRowHandle = (row: any) => {
  ElMessageBox.confirm('请确认是否导出搜索结果', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    MI_identify.value = true
    return exportHandle(exportApi, {
      ...MI_params,
      filterIds: selectionRows.value.map(e => e.id)
    })
  }).finally(() => {
    MI_identify.value = false
  })
}

const downloadNotesTemplate=()=>{
  exportHandle(downloadNotesTemplateApi,{})
}
const notesTemplateUploading=ref(false)
const importNotesTemplate=({file}:any)=>{
  let formdata=new FormData()
  formdata.append('file',file)
  formdata.append('packId',props.id)
  notesTemplateUploading.value=true
  importNotesTemplageApi(formdata).then((res)=>{
    ElMessage.success('导入成功')
    notesTemplateUploading.value=false
    searchHandle(MI_params)
  }).catch(()=>{
    notesTemplateUploading.value=false
  })
}
const showModifyAmount=ref(false)
const amountInfo=ref<any>({
  advanceAmount:0,
  manualUpdateAmount:"",
  pdIds:[],
  taskId:""
})
const amountRef=ref()
const currentModifyRow = ref<object>({})
const modifyLoading=ref(false)
const rules=ref({
  // manualUpdateAmount:[{required:true,message:"请输入金额",trigger:"change"}]
})
const modifyAmountHandel=(row: any)=>{
  let { advanceItems } = row
  currentModifyRow.value = row
  if(advanceItems.length){
      advanceAmountApi({advanceItems}).then(((res:any)=>{
        showModifyAmount.value=true
        let sum=0
        amountInfo.value.pdIds=res.map((el:any)=>{
          sum+=el.amount
          return el.pid
        })
        amountInfo.value.advanceAmount=sum
        // amountInfo.value.taskId=res[0].taskId||''
        amountInfo.value.taskId=res.length?res.map((item:any)=>item.taskId).join(','):''
      }))
      return
  }
  showModifyAmount.value=true
}
const modifyAmount = (formEl:any)=>{
  if (!formEl) return
  formEl.validate((valid:any) => {
    if (valid) {
      let { advanceAmount, manualUpdateAmount, pdIds } = amountInfo.value
      modifyLoading.value=true
      amountUpdateApi({
        advanceAmount,
        manualUpdateAmount: parseFloat(manualUpdateAmount),
        pdIds,
        // 整行数据返回后端
        packDetail: currentModifyRow.value
      }).then((res:any)=>{
        ElMessage.success("修改成功")
        showModifyAmount.value = false
        searchHandle(MI_params)
      }).finally(()=>{
        modifyLoading.value = false
      })
    }
  })
} 
const closeAmountDialog=(formEl:any)=>{
  if (!formEl) return
  formEl.resetFields()
  amountInfo.value={advanceAmount:0,manualUpdateAmount:"",pdIds:[],taskId:""}
  currentModifyRow.value=""
}
const goCostMatch=()=>{
  router.push({name:"CostMatch",query:{packId:props.id}})
}
const dataStatus=[{value:'processed',label:'已处理'},
    {value:'pending_processing',label:'待处理'},
    {value:'partial_processing',label:'部分处理'}]
const datastatusFilter=(status:string)=>{
  let res=dataStatus.find((el:any)=>el.value==status)
  return res?res.label:''
}


// 驳回
const rejectHandle = (row: any) => {
  ElMessageBox.prompt('请输入驳回备注', '提示').then(({ value }) => {
    MI_identify.value = true
    return rejectApi({id: row.id, note: value}, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('驳回成功')
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })

}


// 批量锁定
const batchLock = () => {
  ElMessageBox.confirm('请确认是否批量锁定,(如无勾选,将锁定整个包)', '提示', {
    type: 'warning'
  }).then(() => {
    MI_identify.value = true
    return lockApi({
      ids: selectionRows.value.reduce((arr: number[], row: any) => {
        if(!row.children || row.children?.length === 0){
          arr.push(row.id)
        } else {
          return arr
        }
        return arr
      }, []),
      packId: props.id
    })
  }).then(() => {
    ElMessage.success('锁定成功')
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

// 批量解锁
const batchUnlock = () => {
  ElMessageBox.confirm('请确认是否批量解锁,(如无勾选,将解锁整个包)', '提示', {
    type: 'warning'
  }).then(() => {
    MI_identify.value = true
    return unlockApi({
      ids: selectionRows.value.reduce((arr: number[], row: any) => {
        if(!row.children || row.children?.length === 0){
          arr.push(row.id)
        } else {
          return arr
        }
        return arr
      }, []),
      packId: props.id
    })
  })
  .then(() => {
    ElMessage.success('锁定成功')
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

// 同步MT数据
const synchronization = () => {
  ElMessageBox.confirm('请确认是否同步MT数据,(如无勾选,将同步整个包MT数据)', '提示', {
    type: 'warning'
  }).then(() => {
    MI_identify.value = true
    return sync_marsApi({
      ids: selectionRows.value.reduce((arr: number[], row: any) => {
        if(!row.children || row.children?.length === 0){
          arr.push(row.id)
        } else {
          return arr
        }
        return arr
      }, []),
      packId: props.id
    })
  })
  .then(() => {
    ElMessage.success('MT数据同步成功')
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })

}

// 同步MT结果
const synchronizationResult = () => {
  ElMessageBox.confirm('请确认是否同步approved状态核销,(如无勾选,将同步整个包MT结果)', '提示', {
    type: 'warning'
  }).then(() => {
    MI_identify.value = true
    return sync_marsResultApi({
      ids: selectionRows.value.reduce((arr: number[], row: any) => {
        if(!row.children || row.children?.length === 0){
          arr.push(row.id)
        } else {
          return arr
        }
        return arr
      }, []),
      packId: props.id
    })
  }).then(() => {
    ElMessage.success('同步成功')
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })

}

// 重算PaynoeerFee
const reCalcHandle = () => {
  ElMessageBox.confirm('请确认是否重算PaynoeerFee', '提示', {
    type: 'warning'
  }).then(() => {
    MI_identify.value = true
    return compute_feeApi({id: props.id}, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('重算PaynoeerFee成功')
    MI_identify.value = false
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

// 检测译员
const verifyInterpreter = () => {
  ElMessageBox.confirm('请确认是否检测译员', '提示').then(() => {
    MI_identify.value = true
    return check_translator_statusApi({
      packId: props.id,
      ids: rowIds.value
    })
  }).finally(() => {
    MI_identify.value = false
  })
}

// --------------
const getSummaries = ({ columns, data }: any) => {
  let sums: string[] = ['合计']
  columns.forEach((col:any, index: number) => {
    if (index === 0) return;
    if([
      'paymentAmount', 'advanceAmount', 'actualPaymentAmount',
      'paypalPaymentAmount', 'paypalFeeAmount', 'payoneerPaymentAmount',
      'payoneerFeeAmount', 'cloudPaymentAmount', 'cloudFeeAmount', 'cloudSpotAmount',
      'matchFlowAmount', 'matchAdvanceFlowAmount', 'diffAmount'
    ].includes(col.property)){
      // console.log(col.property, rowTotal);
      
      sums[index] = getNumber(rowTotal[col.property])
    }
  })

  return sums
}




return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlexibleForm, _mergeProps({
      ref: "searchForm",
      class: "mb-10"
    }, {
        initSearch: true,
        title: true,
        searchConfig: searchConfig.value,
      }, { onSearchFn: searchHandle }), null, 16),
    _createVNode(_component_el_space, { wrap: "" }, {
      default: _withCtx(() => [
        (!isUnderCheck.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowCheck.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (delHandle())),
          type: "danger"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: exportRowHandle,
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, { onClick: goCostMatch }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: downloadNotesTemplate }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_upload, {
          "show-file-list": false,
          "http-request": importNotesTemplate,
          disabled: notesTemplateUploading.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { loading: notesTemplateUploading.value }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (batchLock())),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (batchUnlock())),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (synchronization())),
          disabled: _unref(MI_identify),
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_divider, { direction: "vertical" }),
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (synchronizationResult())),
          disabled: _unref(MI_identify),
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (reCalcHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (verifyInterpreter()))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_el_select, {
          modelValue:  filteredColumn.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (( filteredColumn.value) = $event)),
          filterable: "",
          multiple: "",
          placeholder: "请选择过滤字段",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filteredColOpt, (item) => {
              return _createVNode(_component_el_option, {
                key: item,
                value: item,
                label: item
              }, null, 8, ["value", "label"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "row-key": "id",
      border: "",
      "cell-class-name": tipsCellHandle,
      data: _unref(MI_tableData),
      onRowDblclick: _cache[9] || (_cache[9] = (row) => row.isShowEdit = true),
      "show-summary": "",
      "summary-method": getSummaries,
      onSelectionChange: _cache[10] || (_cache[10] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows),
      "max-height": _unref(MI_height) - 120 + 'px',
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "60",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "译员ID",
          prop: "resourceId",
          "show-overflow-tooltip": "",
          fixed: ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, [
              (row.advance === true)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.resourceId), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.resourceId), 1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "译员名字",
          prop: "resourceName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "支付方式",
          prop: "payMethod",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            (row.isShowEdit !== true)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(row.payMethod), 1))
              : _createCommentVNode("", true),
            (row.isShowEdit === true)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: row.payMethod,
                  "onUpdate:modelValue": ($event: any) => ((row.payMethod) = $event),
                  clearable: "",
                  placeholder: "请选择支付方式"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "PAYPAL",
                      value: "paypal"
                    }),
                    _createVNode(_component_el_option, {
                      label: "WISE",
                      value: "wise"
                    }),
                    _createVNode(_component_el_option, {
                      label: "BANKTRANSFER",
                      value: "banktransfer"
                    }),
                    _createVNode(_component_el_option, {
                      label: "PAYONEER",
                      value: "payoneer"
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "支付状态",
          prop: "payStatus",
          "show-overflow-tooltip": "",
          formatter: (row) => _unref(statusFilter)(row.payStatus)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "账号",
          prop: "accountNumber",
          "show-overflow-tooltip": "",
          width: "160"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", _hoisted_15, [
              (row.isShowEdit !== true)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(row.accountNumber), 1))
                : _createCommentVNode("", true),
              (row.isShowEdit === true)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    placeholder: "请输入账号",
                    modelValue: row.accountNumber,
                    "onUpdate:modelValue": ($event: any) => ((row.accountNumber) = $event),
                    clearable: "",
                    maxlength: "400"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (isColumnHidden('银行名字'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "银行名字",
              prop: "bankName",
              "show-overflow-tooltip": "",
              width: "160"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_17, [
                  (row.isShowEdit !== true)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(row.bankName), 1))
                    : _createCommentVNode("", true),
                  (row.isShowEdit === true)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        placeholder: "请输入银行名字",
                        modelValue: row.bankName,
                        "onUpdate:modelValue": ($event: any) => ((row.bankName) = $event),
                        clearable: "",
                        maxlength: "400"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('银行地址'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "银行地址",
              prop: "bankAddress",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_19, [
                  (row.isShowEdit !== true)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(row.bankAddress), 1))
                    : _createCommentVNode("", true),
                  (row.isShowEdit === true)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        placeholder: "请输入银行地址",
                        modelValue: row.bankAddress,
                        "onUpdate:modelValue": ($event: any) => ((row.bankAddress) = $event),
                        clearable: "",
                        maxlength: "400"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('银行国家/地区'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "银行国家/地区",
              prop: "beneficiaryBankCountry",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({ row }) => [
                (row.isShowEdit !== true)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(row.beneficiaryBankCountry), 1))
                  : _createCommentVNode("", true),
                (row.isShowEdit === true)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 1,
                      modelValue: row.beneficiaryBankCountry,
                      "onUpdate:modelValue": ($event: any) => ((row.beneficiaryBankCountry) = $event),
                      clearable: "",
                      placeholder: "请选择银行国家/地区"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countrieList), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.id,
                            key: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('银行代号或国际汇款代码'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              label: "银行代号或国际汇款代码",
              prop: "beneficiaryBankSwiftAddress",
              "show-overflow-tooltip": "",
              width: "170"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_22, [
                  (row.isShowEdit !== true)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(row.beneficiaryBankSwiftAddress), 1))
                    : _createCommentVNode("", true),
                  (row.isShowEdit === true)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        placeholder: "请输入银行代号或国际汇款代码",
                        modelValue: row.beneficiaryBankSwiftAddress,
                        "onUpdate:modelValue": ($event: any) => ((row.beneficiaryBankSwiftAddress) = $event),
                        clearable: "",
                        maxlength: "400"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "收款单位或人员全称",
          prop: "beneficiaryName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (row.isShowEdit !== true)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(row.beneficiaryName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              (row.isShowEdit === true)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    placeholder: "请输入收款单位或人员全称",
                    modelValue: row.beneficiaryName,
                    "onUpdate:modelValue": ($event: any) => ((row.beneficiaryName) = $event),
                    clearable: "",
                    maxlength: "400"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (isColumnHidden('收款人地址'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              label: "收款人地址",
              prop: "beneficiaryAddress",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_26, [
                  (row.isShowEdit !== true)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(row.beneficiaryAddress), 1))
                    : _createCommentVNode("", true),
                  (row.isShowEdit === true)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        placeholder: "请输入收款人地址",
                        modelValue: row.beneficiaryAddress,
                        "onUpdate:modelValue": ($event: any) => ((row.beneficiaryAddress) = $event),
                        clearable: "",
                        maxlength: "400"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('收款人身份证号'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              label: "收款人身份证号",
              prop: "beneficiaryCardId",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('收款人联系电话'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              label: "收款人联系电话",
              prop: "beneficiaryPhone",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('备注'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 7,
              label: "备注",
              prop: "note",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "译员币种",
          prop: "resourceCurrency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "提现金额",
          prop: "paymentAmount",
          "show-overflow-tooltip": "",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", {
              class: _normalizeClass(row.negative?'red-color':'')
            }, _toDisplayString(_unref(getNumber)(row.paymentAmount)), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "付款公司",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "支付币种",
          prop: "payCurrency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "预付金额",
          prop: "advanceAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        (isColumnHidden('开票类型'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 8,
              label: "开票类型",
              prop: "invoiceType",
              "show-overflow-tooltip": "",
              formatter: (row)=>_unref(makeInvoiceTypeOption)()[row.invoiceType]
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('服务方类型'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 9,
              label: "服务方类型",
              prop: "serviceType",
              "show-overflow-tooltip": "",
              formatter: (row)=>_unref(serviceTypeOption)()[row.serviceType]
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('汇率'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 10,
              label: "汇率",
              prop: "exchangeRate",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('适用增值税税率'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 11,
              label: "适用增值税税率",
              prop: "taxRate",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('扣除手续费/税后金额'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 12,
              label: "扣除手续费/税后金额",
              prop: "afterDeductAmount",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "支付金额",
          prop: "actualPaymentAmount",
          width: "120",
          align: "right"
        }, {
          default: _withCtx(({ row }) => [
            (row.advance === true)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "dark",
                  content: "有预付款，是否调整支付金额",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(row.actualPaymentAmount)), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(getNumber)(row.actualPaymentAmount)), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "paypal支付译员金额",
          prop: "paypalPaymentAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        (isColumnHidden('paypal手续费'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 13,
              label: "paypal手续费",
              prop: "paypalFeeAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "120"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('payoneer支付译员金额'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 14,
              label: "payoneer支付译员金额",
              prop: "payoneerPaymentAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "110"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('payoneer手续费'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 15,
              label: "payoneer手续费",
              prop: "payoneerFeeAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "140"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "云账户支付译员金额",
          prop: "cloudPaymentAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        (isColumnHidden('云账户服务费'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 16,
              label: "云账户服务费",
              prop: "cloudFeeAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "110"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('云账户返点'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 17,
              label: "云账户返点",
              prop: "cloudSpotAmount",
              "show-overflow-tooltip": "",
              align: "right"
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('手动修改金额'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 18,
              label: "手动修改金额",
              prop: "manualUpdateAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "110"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "支付备注",
          prop: "payNotes",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "火星同步",
          prop: "syncMarsStatus",
          width: "100"
        }, {
          default: _withCtx(({row}) => [
            (row.syncMarsStatus === 'failed')
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "失败"))
              : _createCommentVNode("", true),
            (row.syncMarsStatus === 'succeed')
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, "成功"))
              : _createCommentVNode("", true),
            (row.syncMarsStatus === 'not_synced')
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "未同步"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (isColumnHidden('提现单核销金额'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 19,
              label: "提现单核销金额",
              prop: "matchFlowAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "130"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('预付单核销金额'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 20,
              label: "预付单核销金额",
              prop: "matchAdvanceFlowAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "130"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('核销币种'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 21,
              label: "核销币种",
              prop: "matchFlowCurrency",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('差异金额'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 22,
              label: "差异金额",
              prop: "diffAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber),
              width: "110"
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (isColumnHidden('差异率'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 23,
              label: "差异率",
              prop: "diffRatio",
              "show-overflow-tooltip": "",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.diffRatio + '%'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('提现单状态'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 24,
              label: "提现单状态",
              prop: "status",
              "show-overflow-tooltip": "",
              align: "right"
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('关单人'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 25,
              label: "关单人",
              prop: "closeUser",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('关单时间'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 26,
              label: "关单时间",
              prop: "closeTime",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.closeTime ? _unref(dayjs)(row.closeTime).format('YYYY-MM-DD HH:mm:ss') : ''), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('关单备注'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 27,
              label: "关单备注",
              prop: "closeNotes",
              width: "140",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_32, [
                  (row.isShowEdit !== true)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(row.closeNotes), 1))
                    : _createCommentVNode("", true),
                  (row.isShowEdit === true)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        placeholder: "请输入关单备注",
                        modelValue: row.closeNotes,
                        "onUpdate:modelValue": ($event: any) => ((row.closeNotes) = $event),
                        clearable: "",
                        maxlength: "400"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('同步火星人'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 28,
              label: "同步火星人",
              prop: "syncMarsUser",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('同步火星时间'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 29,
              label: "同步火星时间",
              prop: "syncMarsTime",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.syncMarsTime ? _unref(dayjs)(row.syncMarsTime).format('YYYY-MM-DD HH:mm:ss') : ''), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('译员账户状态'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 30,
              label: "译员账户状态",
              prop: "translatorAccountStatus",
              "show-overflow-tooltip": "",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                (row.translatorAccountStatus === -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "译员不存在(注册失败)"))
                  : _createCommentVNode("", true),
                (row.translatorAccountStatus === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, "收款人正在等待KYC审查，目前无法提交付款。如果Payoneer要求收款人提供进一步的信息以供批准，将在回复中作为原因进行沟通"))
                  : _createCommentVNode("", true),
                (row.translatorAccountStatus === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "收款人被批准，客户可向收款人提交付款"))
                  : _createCommentVNode("", true),
                (row.translatorAccountStatus === 99)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 收款人被拒，客户无法向收款人提交付款"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isColumnHidden('进度'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 31,
              label: "进度",
              fixed: "right",
              prop: "dataStatus",
              "show-overflow-tooltip": "",
              formatter: (row)=>datastatusFilter(row.dataStatus)
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "165"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                (row.isShowEdit === true)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      onClick: ($event: any) => (inlineEditHandle(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_38
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.isShowEdit === true)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      onClick: ($event: any) => {row.isShowEdit = false; searchHandle(_unref(MI_params));}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.isShowEdit !== true)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_unref(tipsRows).includes(row.id.toString()))
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            type: "primary",
                            onClick: ($event: any) => (modifyErrRowHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_link, {
                            key: 1,
                            type: "primary",
                            onClick: ($event: any) => (modifyHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_41
                            ]),
                            _: 2
                          }, 1032, ["onClick"])),
                      _createVNode(_component_el_link, {
                        type: "primary",
                        onClick: ($event: any) => (modifyAmountHandel(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_link, {
                        onClick: ($event: any) => (rejectHandle(row)),
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createElementVNode("span", null, "当前选中了" + _toDisplayString(_unref(selectionRows).length) + "行数据", 1),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[12] || (_cache[12] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [30, 50, 100, 400],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: pageCg,
      onSizeChange: sizeCg
    }, null, 8, ["total", "currentPage", "page-size", "disabled"]),
    _createVNode(_component_el_dialog, {
      title: "修改",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((modifyFg).value = $event)),
      width: "1100px"
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "数据校验",
      modelValue: isShowCheck.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isShowCheck).value = $event)),
      width: "930px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (isShowCheck.value = false)),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_45
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (dataCheck())),
          loading: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_46
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _hoisted_44
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[22] || (_cache[22] = ($event: any) => (closeAmountDialog(amountRef.value))),
      title: "修改金额",
      modelValue: showModifyAmount.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((showModifyAmount).value = $event)),
      width: "350px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (showModifyAmount.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_47
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: modifyLoading.value,
          type: "primary",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (modifyAmount(amountRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          model: amountInfo.value,
          style: {"max-width":"460px"},
          ref_key: "amountRef",
          ref: amountRef,
          rules: rules.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "任务ID:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  style: {"width":"240px"},
                  autosize: "",
                  disabled: "",
                  modelValue: amountInfo.value.taskId,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((amountInfo.value.taskId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "预付款金额:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: "",
                  modelValue: amountInfo.value.advanceAmount,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((amountInfo.value.advanceAmount) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "修改金额:",
              prop: "manualUpdateAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: amountInfo.value.manualUpdateAmount,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((amountInfo.value.manualUpdateAmount) = $event)),
                  maxlength: "100",
                  placeholder: "请输入金额",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})